<app-spin-or-content [isSpin]="isLoading">
	@if (activeVersion) {
		<version
			[actObject]="activeVersion"
			(onSaveNew)="handleSaveNew($event)"
		/>
	} @else if (isLatestInUse) {
		<app-btn-ext
			text="new_version"
			(clickEv)="createFromLatest()"
		/>
	}

	@if (versions.length) {
		<p
			class="followup-title"
			(click)="versionsIsOpen = !versionsIsOpen"
		>
			<app-icon [icon]="versionsIsOpen ? 'narrow' : 'expand'" />
			<span class="pointer"> {{ "old_versions" | langVal }} </span>
		</p>

		@if (versionsIsOpen) {
			<app-table-wrap fieldsStr="date,version,see_document">
				@for (version of versions; track version.id) {
					<row
						[actObject]="version"
						[disabled]="$first ? isLatestInUse : true"
						[canOpen]="$first ? !activeVersion : true"
					/>
				}
			</app-table-wrap>
		}
	}
</app-spin-or-content>
